module.exports = __webpack_public_path__ + "static/media/Morph2.0dec3e99.png";